export default {
    GET_VENDORS: "[zina_flow][vendor] get all vendors",
    GET_VENDORS_SUCCESS: "[zina_flow][vendor] get all vendors SUCCESS",
    GET_VENDORS_FAIL: "[zina_flow][vendor] get all vendors FAIL",
    UPDATE_PAGINATION: "[zina_flow][vendor] update vendor pagination",
    CHANGE_PAGE: "[zina_flow][vendor] change vendor page",
    FILTER_LIST: "[zina_flow][vendor] change vendor filters"
};
